import { useLayoutEffect, useState } from "react";
import { IExamsTableRowData } from "./types";

const AVERAGE_CHAR_WIDTH = 7; // average width of one char "px"
const ADDITIONAL_RISK_WIDTH = 40; // paddings, borders, margins risk factors wrap and all items
const MIN_RISK_FACTORS_WIDTH = 120; // min column width

export const useRiskFactorsColumnWidth = (
  rows: IExamsTableRowData[],
  shouldRecalculateWidth: boolean
): number => {
  const [maxRiskFactorColumnWidth, setMaxRiskFactorColumnWidth] =
    useState<number>(null);

  useLayoutEffect(() => {
    if (shouldRecalculateWidth) {
      const maxLengthRiskFactor = rows
        .reduce((acc, cur) => {
          const horse = cur.horse;

          if (horse.riskFactorsCount) {
            acc.push({
              risksCount: horse.riskFactorsCount,
              charsCount: horse.riskFactorShortDescriptions.join("").length
            });
          }

          return acc;
        }, [])
        .sort((l1, l2) => {
          return l2.charsCount - l1.charsCount || l2.risksCount - l1.risksCount;
        })[0];

      const maxRiskFactorsWidth =
        AVERAGE_CHAR_WIDTH * maxLengthRiskFactor?.charsCount +
        ADDITIONAL_RISK_WIDTH * maxLengthRiskFactor?.risksCount;
      const riskFactorColumnWidth = Math.max(
        maxRiskFactorsWidth,
        MIN_RISK_FACTORS_WIDTH
      );

      setMaxRiskFactorColumnWidth(riskFactorColumnWidth);
    }
  }, [rows, shouldRecalculateWidth]);

  return maxRiskFactorColumnWidth;
};
